export const makeRandomKey = () => `k-${Math.random() * 10000000000}`

export const sortNumbersKeepSpaces = (a, b) => {
    // expects an array number or spaces
    const aIsNumber = !isNaN(a);
    const bIsNumber = !isNaN(b);

    if (aIsNumber && !bIsNumber) {
        return 1; // Keep 'a' before 'b'
    } else if (!aIsNumber && bIsNumber) {
        return -1; // Move 'a' after 'b'
    }
    return 0; // Keep original order
};

// write to local storage
export const setLocalStorage = (key, value) => {
    localStorage.setItem(key, JSON.stringify(value))
}


// read from local storage
export const getLocalStorage = (key) => {
    const value = localStorage.getItem(key)
    if (value) {
        try {
            return JSON.parse(value)
        } catch (e) {
            return null
        }
    }
    return null
}

export const escapeString = (text) => text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')


// convert uuid to hex format
export const convertToHex = (uuid) => {
    if (!uuid) return uuid;
    return uuid.replace(/-/g, '');
};

// extract the extension from the filename
export const getExtension = (filename) => {
    return filename.split('.').pop();
}

 // Function to get MIME type and headers based on file extension
export const getFileTypeConfig = (extension) => {
        const ext = extension?.toLowerCase() || '';

        switch (ext) {
            case 'mp4':
                return {
                    mimeType: 'video/mp4',
                    accept: 'video/mp4, video/*'
                };
            case 'webm':
                return {
                    mimeType: 'video/webm',
                    accept: 'video/webm, video/*'
                };
            case 'mts':
            case 'm2ts':
            case 'ts':
                return {
                    mimeType: 'video/mp2t',
                    accept: 'video/mp2t, video/*'
                };
            case 'mov':
                return {
                    mimeType: 'video/quicktime',
                    accept: 'video/quicktime, video/*'
                };
            case 'mp2':
                return {
                    mimeType: 'video/mpeg',
                    accept: 'video/mpeg, video/*'
                };
            case 'm4p':
            case 'm4v':
                return {
                    mimeType: 'video/mp4',
                    accept: 'video/mp4, video/*'
                };
            case 'mxf':
                return {
                    mimeType: 'application/mxf',
                    accept: 'application/mxf, video/*'
                };
            case 'mp3':
                return {
                    mimeType: 'audio/mpeg',
                    accept: 'audio/mpeg, audio/*'
                };
            case 'gif':
                return {
                    mimeType: 'image/gif',
                    accept: 'image/gif, image/*'
                };
            case 'srt':
                return {
                    mimeType: 'application/x-subrip',
                    accept: 'application/x-subrip, text/plain, */*'
                };
            case 'vtt':
                return {
                    mimeType: 'text/vtt',
                    accept: 'text/vtt, text/plain, */*'
                };
            case 'zip':
                return {
                    mimeType: 'application/zip',
                    accept: 'application/zip, application/octet-stream, */*'
                };
            default:
                return {
                    mimeType: 'application/octet-stream',
                    accept: 'application/octet-stream, */*'
                };
        }
    };


// Generic sorting function that handles different data types
export const sortData = (data, field, isAscending = true) => {
    return [...data].sort((a, b) => {
        let aValue = a[field];
        let bValue = b[field];
        
        // Handle null/undefined values
        if (aValue == null && bValue == null) return 0;
        if (aValue == null) return isAscending ? 1 : -1;
        if (bValue == null) return isAscending ? -1 : 1;
        
        // Handle date sorting
        if (field === 'created' || field === 'date' || field.includes('date') || field.includes('time')) {
            aValue = new Date(aValue);
            bValue = new Date(bValue);
        }
        
        // Handle string sorting (case insensitive)
        if (typeof aValue === 'string' && typeof bValue === 'string') {
            aValue = aValue.toLowerCase();
            bValue = bValue.toLowerCase();
        }
        
        // Compare values
        if (aValue < bValue) return isAscending ? -1 : 1;
        if (aValue > bValue) return isAscending ? 1 : -1;
        return 0;
    });
};


// update header sort state
export const updateHeaderSortState = (header, sortIndex) => {
    return header.map((item, index) => {
        if (index === sortIndex) {
            return { ...item, isUp: !item.isUp };
        }
        return { ...item, isUp: false };
    });
};


// complete sort handler
export const handleSort = (data, header, sortIndex, setData, setHeader) => {
    // Update header state
    const newHeader = updateHeaderSortState(header, sortIndex);
    setHeader(newHeader);
    
    // Get sort field and direction
    const sortField = header[sortIndex].field;
    const isAscending = newHeader[sortIndex].isUp;
    
    // Sort data
    const sortedData = sortData(data, sortField, isAscending);
    setData(sortedData);
};

export const clockDuration = (duration, precision) => {
    if (precision) {
        duration = [duration[0].slice(0, -1), duration[1].slice(0, -1)]
    }
    return duration
}

export const convertToSeconds = (duration) => {
    const [hours, minutes, seconds] = duration.split(':').map(Number);
    return hours * 3600 + minutes * 60 + seconds;
}

// Reliable browser detection function
export const detectBrowser = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    const vendor = navigator.vendor?.toLowerCase() || '';
    
    // Browser detection object to return
    const browserInfo = {
        name: 'unknown',
        version: null,
        isSafari: false,
        isFirefox: false,
        isChrome: false,
        isEdge: false,
        isMobile: false
    };
    
    // Detect mobile devices
    browserInfo.isMobile = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
    
    // Chrome detection (must come before Safari since Chrome includes Safari in user agent)
    if (userAgent.includes('chrome') && !userAgent.includes('edg') && vendor.includes('google')) {
        browserInfo.name = 'chrome';
        browserInfo.isChrome = true;
        const chromeMatch = userAgent.match(/chrome\/(\d+)/);
        if (chromeMatch) {
            browserInfo.version = chromeMatch[1];
        }
    }
    // Edge detection (new Chromium-based Edge)
    else if (userAgent.includes('edg/') || userAgent.includes('edge/')) {
        browserInfo.name = 'edge';
        browserInfo.isEdge = true;
        const edgeMatch = userAgent.match(/edg?\/(\d+)/);
        if (edgeMatch) {
            browserInfo.version = edgeMatch[1];
        }
    }
    // Safari detection
    else if (userAgent.includes('safari') && vendor.includes('apple') && !userAgent.includes('chrome')) {
        browserInfo.name = 'safari';
        browserInfo.isSafari = true;
        const safariMatch = userAgent.match(/version\/(\d+)/);
        if (safariMatch) {
            browserInfo.version = safariMatch[1];
        }
    }
    // Firefox detection
    else if (userAgent.includes('firefox')) {
        browserInfo.name = 'firefox';
        browserInfo.isFirefox = true;
        const firefoxMatch = userAgent.match(/firefox\/(\d+)/);
        if (firefoxMatch) {
            browserInfo.version = firefoxMatch[1];
        }
    }
    // Additional Safari detection for edge cases
    else if (vendor.includes('apple') && !userAgent.includes('chrome') && !userAgent.includes('firefox')) {
        browserInfo.name = 'safari';
        browserInfo.isSafari = true;
    }
    
    return browserInfo;
};

// Convenience functions for quick browser checks
export const isSafari = () => detectBrowser().isSafari;
export const isFirefox = () => detectBrowser().isFirefox;
export const isChrome = () => detectBrowser().isChrome;
export const isEdge = () => detectBrowser().isEdge;
export const isMobileBrowser = () => detectBrowser().isMobile;

// Get browser name as string
export const getBrowserName = () => detectBrowser().name;

// Mobile platform detection function
export const detectMobilePlatform = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    const platform = navigator.platform?.toLowerCase() || '';
    
    // Platform detection object to return
    const platformInfo = {
        platform: 'unknown',
        isAndroid: false,
        isIOS: false,
        isIPhone: false,
        isIPad: false,
        isIPod: false,
        isMobile: false,
        isTablet: false,
        version: null
    };
    
    // Android detection
    if (userAgent.includes('android')) {
        platformInfo.platform = 'android';
        platformInfo.isAndroid = true;
        platformInfo.isMobile = true;
        
        // Extract Android version
        const androidMatch = userAgent.match(/android\s([0-9\.]*)/);
        if (androidMatch) {
            platformInfo.version = androidMatch[1];
        }
        
        // Detect if it's a tablet (Android tablets usually don't have "mobile" in user agent)
        platformInfo.isTablet = !userAgent.includes('mobile');
        
        return platformInfo;
    }
    
    // iOS detection
    const isIOSDevice = /iphone|ipad|ipod/.test(userAgent) || 
                       (platform.includes('mac') && navigator.maxTouchPoints > 1);
    
    if (isIOSDevice) {
        platformInfo.platform = 'ios';
        platformInfo.isIOS = true;
        platformInfo.isMobile = true;
        
        // Specific iOS device detection (order matters - check iPod before iPhone)
        if (userAgent.includes('ipod')) {
            platformInfo.isIPod = true;
            platformInfo.isTablet = false;
        } else if (userAgent.includes('ipad')) {
            platformInfo.isIPad = true;
            platformInfo.isTablet = true;
        } else if (userAgent.includes('iphone')) {
            platformInfo.isIPhone = true;
            platformInfo.isTablet = false;
        } else if (platform.includes('mac') && navigator.maxTouchPoints > 1) {
            // This catches iPad running in desktop mode
            platformInfo.isIPad = true;
            platformInfo.isTablet = true;
        }
        
        // Extract iOS version
        const iosMatch = userAgent.match(/os\s([0-9_]*)/);
        if (iosMatch) {
            platformInfo.version = iosMatch[1].replace(/_/g, '.');
        }
        
        return platformInfo;
    }
    
    // Check for other mobile indicators
    const mobileIndicators = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile/i;
    if (mobileIndicators.test(userAgent)) {
        platformInfo.isMobile = true;
    }
    
    return platformInfo;
};

// Convenience functions for quick platform checks
export const isAndroid = () => detectMobilePlatform().isAndroid;
export const isIOS = () => detectMobilePlatform().isIOS;
export const isIPhone = () => detectMobilePlatform().isIPhone;
export const isIPad = () => detectMobilePlatform().isIPad;
export const isIPod = () => detectMobilePlatform().isIPod;
export const isMobileDevice = () => detectMobilePlatform().isMobile;
export const isTabletDevice = () => detectMobilePlatform().isTablet;

// Get platform name as string
export const getMobilePlatformName = () => detectMobilePlatform().platform;

// Get local IP address using WebRTC
export const getLocalIPAddress = () => {
    return new Promise((resolve, reject) => {
        // Check if WebRTC is supported
        if (!window.RTCPeerConnection) {
            reject(new Error('WebRTC not supported'));
            return;
        }

        const pc = new RTCPeerConnection({
            iceServers: [{ urls: 'stun:stun.l.google.com:19302' }]
        });

        const ips = new Set();

        pc.onicecandidate = (event) => {
            if (!event.candidate) {
                // ICE gathering complete
                pc.close();
                if (ips.size === 0) {
                    reject(new Error('No IP addresses found'));
                } else {
                    // Return the first non-localhost IP
                    const ipArray = Array.from(ips);
                    const localIP = ipArray.find(ip => 
                        ip.startsWith('192.168.') || 
                        ip.startsWith('10.') || 
                        ip.startsWith('172.')
                    ) || ipArray[0];
                    resolve(localIP);
                }
                return;
            }

            const candidate = event.candidate.candidate;
            const ipMatch = candidate.match(/(\d+\.\d+\.\d+\.\d+)/);
            
            if (ipMatch && ipMatch[1]) {
                const ip = ipMatch[1];
                // Filter out localhost and invalid IPs
                if (ip !== '127.0.0.1' && ip !== '0.0.0.0' && !ip.startsWith('169.254.')) {
                    ips.add(ip);
                }
            }
        };

        // Create a data channel to trigger ICE gathering
        pc.createDataChannel('test');
        
        // Create offer and set local description to start ICE gathering
        pc.createOffer()
            .then(offer => pc.setLocalDescription(offer))
            .catch(reject);

        // Timeout after 5 seconds
        setTimeout(() => {
            pc.close();
            if (ips.size === 0) {
                reject(new Error('Timeout: No IP addresses found'));
            }
        }, 5000);
    });
};

// Get external IP address using external service
export const getExternalIPAddress = async () => {
    try {
        const response = await fetch('https://api.ipify.org?format=json');
        const data = await response.json();
        return data.ip;
    } catch (error) {
        throw new Error('Failed to get external IP: ' + error.message);
    }
};

// Comprehensive IP detection function
export const getIPAddresses = async () => {
    const result = {
        local: null,
        external: null,
        error: null
    };

    try {
        // Try to get local IP
        try {
            result.local = await getLocalIPAddress();
        } catch (error) {
            console.warn('Could not get local IP:', error.message);
        }

        // Try to get external IP
        try {
            result.external = await getExternalIPAddress();
        } catch (error) {
            console.warn('Could not get external IP:', error.message);
        }

        if (!result.local && !result.external) {
            result.error = 'Could not determine any IP addresses';
        }

    } catch (error) {
        result.error = error.message;
    }

    return result;
};

export const converToStorageUnit = (size) => {
    const units = ['B', 'KB', 'MB', 'GB', 'TB'];
    
    // Handle edge cases
    if (size <= 0) {
        return '0.00 B';
    }
    
    const index = Math.floor(Math.log2(size) / 10);
    const clampedIndex = Math.max(0, Math.min(index, units.length - 1));
    
    return (size / Math.pow(1024, clampedIndex)).toFixed(2) + ' ' + units[clampedIndex];
}


 export const getStatusColor = (status) => {
        switch (status) {
            case 'active': return 'success';
            case 'trialing': return 'info';
            case 'canceled': return 'warning';
            case 'past_due': return 'error';
            default: return 'default';
        }
 };
    
 export const formatDate = (timestamp) => {
        if (!timestamp) return 'N/A';
        return new Date(timestamp * 1000).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    };

export const capitalize = (str) => str ? str.charAt(0).toUpperCase() : '';